<template>
	<el-dialog
		title="更换管理员"
		:visible.sync="dialogVisible"
		width="480px"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:show-close="false"
		destroy-on-close
	>
		<el-form ref="formRef" :model="form" :rules="rules" label-position="top">
			<el-form-item label="新手机号码" prop="phone">
				<el-input v-model.trim="form.phone" placeholder="请输入新手机号码" maxlength="11" />
			</el-form-item>
			<el-form-item label="短信验证码" prop="verifyCode">
				<div class="code-row">
					<el-input v-model.trim="form.verifyCode" placeholder="请输入验证码" maxlength="6" />
					<el-button :disabled="waitNum > 0" plain type="primary" @click="toSendMsg" class="send-btn">
						{{ waitNum > 0 ? waitNum + '秒后重发' : '获取验证码' }}
					</el-button>
				</div>
			</el-form-item>
		</el-form>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">取消</el-button>
				<el-button size="small" type="primary" :loading="saving" @click="handleConfirm">确定</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import { getMemberSms } from '@/api/user/login';
import TMessage from '@/utils/TMessage';
import { postMemberPhoneNew, postMemberUpdatePhoneMail } from '@/api/user/user.js';
import mtils from 'mtils';

export default {
	name: 'EditNewPhone',
	data() {
		const validatePhone = (rule, value, callback) => {
			if (!value) return callback(new Error('请输入手机号码'));
			if (!mtils.validation.isMobile(value)) return callback(new Error('手机号码格式不正确'));
			callback();
		};
		return {
			dialogVisible: false,
			saving: false,
			oldPhone: '',
			form: {
				phone: '',
				verifyCode: '',
				verifyKey: ''
			},
			rules: {
				phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
				verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
			},
			waitNum: 0,
			wtimer: null
		};
	},
	methods: {
		// 外部调用：open(oldPhone)
		open(oldPhone) {
			this.oldPhone = oldPhone || '';
			this.form = { phone: '', verifyCode: '', verifyKey: '' };
			this.dialogVisible = true;
		},

		// 发送验证码到新手机
		toSendMsg() {
			this.$refs.formRef.validateField('phone', err => {
				if (!err) {
					this.startWait();
					getMemberSms(this.form.phone)
						.then(res => {
							const { code, data, msg } = res;
							if (code == 200) {
								this.form.verifyKey = data;
								TMessage.success('验证码已发送');
							} else {
								this.stopWait();
								TMessage.warning(msg || '短信发送失败');
							}
						})
						.catch(() => {
							this.stopWait();
							TMessage.error('发送失败，请重试');
						});
				}
			});
		},

		startWait() {
			this.waitNum = 60;
			if (this.wtimer) this.stopWait();
			this.wtimer = setInterval(() => {
				this.waitNum--;
				if (this.waitNum <= 0) this.stopWait();
			}, 1000);
		},

		stopWait() {
			clearInterval(this.wtimer);
			this.wtimer = null;
			this.waitNum = 0;
		},

		handleClose() {
			this.dialogVisible = false;
			this.stopWait();
			this.$refs.formRef && this.$refs.formRef.resetFields();
		},

		handleConfirm() {
			this.$refs.formRef.validate(valid => {
				if (valid) {
					this.saving = true;
					postMemberPhoneNew(this.form)
						.then(res => {
							const { code, msg } = res;
							if (code == 200) {
								this.updatePhone();
							} else {
								this.saving = false;
								TMessage.warning(msg || '验证码验证失败');
							}
						})
						.catch(() => {
							this.saving = false;
							TMessage.error('验证失败，请重试');
						});
				}
			});
		},

		updatePhone() {
			const params = {
				oldPhone: this.oldPhone,
				newPhone: this.form.phone,
				itype: 0
			};
			postMemberUpdatePhoneMail(params)
				.then(res => {
					const { code, msg } = res;
					this.saving = false;
					if (code == 200) {
						TMessage.success('手机号更换成功');
						this.handleClose();
						this.$emit('confirmInfo');
					} else {
						TMessage.warning(msg || '手机号更新失败');
					}
				})
				.catch(() => {
					this.saving = false;
					TMessage.error('更新失败，请重试');
				});
		}
	},
	beforeDestroy() {
		this.stopWait();
	}
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}
/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}
/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
.code-row {
	display: flex;
	gap: 10px;
	align-items: center;

	.el-input {
		flex: 1;
	}
	.send-btn {
		white-space: nowrap;
		min-width: 120px;
	}
}
</style>
